export const HCP_MIN_TENTHS = -540
export const HCP_MAX_TENTHS = 100

const HCP_INPUT_PATTERN = /^\+?\d{0,2}(\.\d?)?$/

export const isHcpInputAllowed = (input: string): boolean => {
  return HCP_INPUT_PATTERN.test(input)
}

export const hcpInputToTenths = (input: string): number | undefined => {
  const isPlusHandicap = input.startsWith('+')
  const digits = isPlusHandicap ? input.slice(1) : input

  if (digits === '' || digits === '.') {
    return undefined
  }

  const handicap = Number(digits)

  if (isNaN(handicap)) {
    return undefined
  }

  const tenths = Math.round(handicap * 10)

  if (tenths === 0) {
    return 0
  }

  return isPlusHandicap ? tenths : -tenths
}

export const tenthsToHcpInput = (tenths: number | null | undefined): string => {
  if (typeof tenths !== 'number' || isNaN(tenths)) {
    return ''
  }

  const handicap = String(Math.abs(tenths) / 10)

  return tenths > 0 ? `+${handicap}` : handicap
}

export const isHcpTenthsInRange = (tenths: number): boolean => {
  return tenths >= HCP_MIN_TENTHS && tenths <= HCP_MAX_TENTHS
}
